import { ConstraintPrematureWellShutdownInteractingTargetFormationBase } from './base/constraint-premature-well-shutdown-interacting-target-formation-base';

export class ConstraintPrematureWellShutdownInteractingTargetFormation extends ConstraintPrematureWellShutdownInteractingTargetFormationBase { }